import { gql } from '@apollo/client';
import { ATTRACTION_PAGE_INTERFACE } from './attraction';
import {
  ATTRACTION_INTERFACE,
  CARDMEDIAINTERFACE,
  PRODUCTINTERFACE
} from './commonInterfaces';

const FETCH_PRODUCT_PRIVATE = gql`
  query FETCH_PRODUCT_PRIVATE($slug: JSON!, $Id: String) {
    product: products(where: { slug: $slug }) {
      id: boat_id
      name
      slug
      metaDescription: meta_description
      canonical
      pageTitle: title
      type
      trustBar: trust_bar
      shortDescription: short_description
      longDescription: long_description
      cardMessage: card_message
      trustBar: trust_bar
      tourIncludes: tour_includes
      importantInfo: important_info
      duration
      price
      FAQ
      carousel: carousel_media {
        id
        name
        alt: alternativeText
        url
        fragment: caption
        type: provider_metadata
      }
      cities {
        id
        name
        slug
      }
      reviews {
        id
        rating
      }
      attractions {
        id
        name
        slug
        cardSnippet: snippet
        cardMedia: card_media {
          id
          name
          alt: alternativeText
          url
          fragment: caption
          type: provider_metadata
        }
        cardMediaAlt: media_library {
          id
          name
          alt: alternativeText
          url
          fragment: caption
          type: provider_metadata
        }
        city {
          id
          name
          slug
        }
      }
      relatedProducts: related_products {
        id: boat_id
        name
        slug
        duration
        price
        cardSnippet: snippet
        cardMessage: card_message
        cardMedia: card_media {
          id
          name
          alt: alternativeText
          url
          fragment: caption
          type: provider_metadata
        }
        carousel: carousel_media {
          id
          name
          alt: alternativeText
          url
          fragment: caption
          type: provider_metadata
        }
        reviews {
          id
          rating
        }
      }
      cardMedia: card_media {
        url
      }
      private
    }
    reviews(where: { product: { slug: $slug } }) {
      id
      review
      title
      traveller
      rating
      date
      source
      created_at
    }
    rezdy: boatnew_products(where: { slug: { _eq: $Id } }) {
      id
      rezdy {
        rezdyId: rezdy_id
      }
      booking_cutoff
    }
  }
`;

const FETCH_PRODUCT_CAROUSAL = gql`
  query FETCH_PRODUCT_PRIVATE($slug: JSON!, $Id: String) {
    product: products(where: { slug: $slug }) {
      id: boat_id
      name
      slug
      metaDescription: meta_description
      canonical
      pageTitle: title
      type
      trustBar: trust_bar
      shortDescription: short_description
      longDescription: long_description
      cardMessage: card_message
      trustBar: trust_bar
      tourIncludes: tour_includes
      importantInfo: important_info
      duration
      price
      FAQ
      carousel: carousel_media {
        id
        name
        alt: alternativeText
        url
        fragment: caption
        type: provider_metadata
      }
    }
  }
`;

const FETCH_PRODUCT_DETAILS = gql`
  query FETCH_PRODUCT_DETAILS($slug: JSON!) {
    productDetails(where: { slug: $slug }) {
      rezdyId
      adult
      child
      infant
      options {
        id
        start_time
      }
    }
  }
`;

const FETCH_PRODUCT_URL = gql`
  query FETCH_PRODUCT_URL($id: JSON!) {
    product: products(where: { boat_id: $id }) {
      cardMedia: card_media {
        url
      }
    }
  }
`;

const FETCH_PRODUCT_BOAT = gql`
  query FETCH_PRODUCT_BOAT($id: String!) {
    product: boatnew_products_by_pk(id: $id) {
      id
      quantityMin: quantity_min
      quantityMax: quantity_max
      cancelCutOff: cancel_cutoff
      citiesProducts: cities_products {
        city {
          timeZone: time_zone
          gmb_link
        }
      }
    }
  }
`;
interface FETCH_PRODUCT_INTERFACE {
  product: [
    {
      id: string;
      name: string;
      slug: string;
      metaDescription: string;
      canonical: string;
      pageTitle: string;
      type: string;
      trustBar: string;
      shortDescription: string;
      longDescription: string;
      cardMessage: string;
      tourIncludes: [string];
      importantInfo: [string];
      duration: number;
      price: number;
      FAQ: [string];
      carousel: [CARDMEDIAINTERFACE];
      cities: [
        {
          id: string;
          name: string;
          slug: string;
        }
      ];
      attractions: [ATTRACTION_INTERFACE];
      relatedProducts: [PRODUCTINTERFACE];
      cardMedia: {
        url: string;
      };
      private: string;
    }
  ];
}
interface FETCH_PRODUCT_DETAILS_INTERFACE {
  productDetails: [
    {
      rezdyId: string;
      adult: number;
      child: number;
      infant: number;
      options: {
        id: string;
        start_time: string;
      };
    }
  ];
}
interface FETCH_PRODUCT_URL_INTERFACE {
  product: {
    cardMedia: [CARDMEDIAINTERFACE];
  };
}
interface FETCH_PRODUCT_BOAT_INTERFACE {
  product: {
    id: string;
    quantityMin: number;
    quantityMax: number;
    cancelCutOff: number;
    citiesProducts: [
      {
        city: {
          timeZone: string;
          gmb_link: {
            city: string;
          };
        };
      }
    ];
  };
}
export {
  FETCH_PRODUCT_PRIVATE,
  FETCH_PRODUCT_DETAILS,
  FETCH_PRODUCT_URL,
  FETCH_PRODUCT_BOAT,
  FETCH_PRODUCT_CAROUSAL
};
export type {
  FETCH_PRODUCT_INTERFACE,
  FETCH_PRODUCT_DETAILS_INTERFACE,
  FETCH_PRODUCT_URL_INTERFACE,
  FETCH_PRODUCT_BOAT_INTERFACE
};
